import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Login from './components/Login';
import Home from './components/Home';
import PrescriptionGrid from './components/common/PrescriptionGrid';
import NeedsTrackingGrid from './components/common/NeedsTrackingGrid';
import NeedsOpenOrders from './components/NeedsOpenOrders';
import SubmittedClaims from './components/common/SubmittedClaims';
import PaidClaims from './components/common/PaidClaims';
import CostShareDetails from './components/common/CostShareDetails';
import CostShareInfo from './components/common/CostShareInfo';
import OpenOrders from './components/OpenOrders';
import SubmittedClaimsOpenOrder from './components/SubmittedClaimsOpenOrder';
import UploadDocuments from './components/UploadDocuments';
import EntirelyCancelledGrid from './components/common/EntirelyCancelledGrid';
import PartiallyCancelledGrid from './components/common/PartiallyCancelledGrid';
import CanceledDetails from './components/common/CanceledDetails';
import FormularyPricingGrid from './components/common/FormularyPricingGrid';
import PaidTaskGrid from './components/PaidTaskGrid';
import PaidTaskOpenOrders from './components/PaidTaskOpenOrders';
import ContactUs from './components/ContactUs';
import DispensedOrderCignaGrid from './components/common/DispensedOrderCignaGrid';
import DispensedCignaOpenOrder from './components/DispensedCignaOpenOrder';
import ErrorPage from './components/common/ErrorPage';
import ForgotPassword from './components/common/ForgotPassword';
import ChangePassword from './components/common/ChangePassword';
import SessionExpire from './components/common/SessionExpire'; // <-- Create this component
import SSOResponsePage from './components/SSOResponsePage';
import Remittance from './components/Remittance';
import ManageUser from './components/ManageUser';
import UnlockOrders from './components/UnlockOrders';
import { HashRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';

const SESSION_TIMEOUT = 20 * 60 * 1000; // 20 minutes

function SessionTimeoutHandler() {
  const navigate = useNavigate();
  const location = useLocation();
  const timerRef = useRef();

  const resetTimer = () => {
  if (timerRef.current) clearTimeout(timerRef.current);
  timerRef.current = setTimeout(() => {
    localStorage.clear();
    sessionStorage.clear();
    if (location.pathname !== '/' && location.pathname !== '/login') {
      navigate('/session-expired');
    }
  }, SESSION_TIMEOUT);
};

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();
    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line
  }, [location.pathname]);

  return null;
}

function App() {

//   useEffect(() => {
//   const handlePopState = (event) => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (user?.userId && user?.pharmacyId) {
//       window.history.pushState(null, '', window.location.href);
//     }
//   };

//   window.history.pushState(null, '', window.location.href); // push initial state
//   window.addEventListener('popstate', handlePopState);

//   return () => {
//     window.removeEventListener('popstate', handlePopState);
//   };
// }, []);


  return (
    <Router>
      <SessionTimeoutHandler />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/process-prescription" element={<PrescriptionGrid />} />
        <Route path="/open-orders" element={<OpenOrders />} />
        <Route path="/needs-tracking" element={<NeedsTrackingGrid />} />
        <Route path="/needs-open-orders" element={<NeedsOpenOrders />} />
        <Route path="/upload-documents" element={<UploadDocuments />} />
        <Route path="/submitted-claims" element={<SubmittedClaims />} />
        <Route path="/submitted-open-orders" element={<SubmittedClaimsOpenOrder />} />
        <Route path="/paid-claims" element={<PaidClaims />} />
        <Route path="/cost-share-details" element={<CostShareDetails />} />
        <Route path="/cost-share-info" element={<CostShareInfo />} />
        <Route path="/entirelly-cancelled-grid" element={<EntirelyCancelledGrid />} />
        <Route path="/partially-cancelled-grid" element={<PartiallyCancelledGrid />} />
        <Route path='/entirelly-cancelled-details' element={<CanceledDetails />} />
        <Route path="/formulary-pricing" element={<FormularyPricingGrid />} />
        <Route path="/paid-task-grid" element={<PaidTaskGrid />} />
        <Route path="/paid-task-open-orders" element={<PaidTaskOpenOrders />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/dispensed-order-cigna" element={<DispensedOrderCignaGrid />} />
        <Route path="/dispensed-cigna-open-order" element={<DispensedCignaOpenOrder />} />
        <Route path="/error-page" element={<ErrorPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/session-expired" element={<SessionExpire />} />
        <Route path="/ResponsePage" element={<SSOResponsePage />} />
        <Route path="/remittance" element={<Remittance />} />
        <Route path="/manage-users" element={<ManageUser />} />
        <Route path="/unlock-order" element={<UnlockOrders />} />
        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;